<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('invoice.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('toHomePage'), href: '/' },
          { text: $t('invoice.pageTitle'), href: '/invoices' },
          { text: $t('create'), active: true }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <ts-loading-banner :loading="loading_eligable">
          <div class="row">
            <div class="col-md-6">
              <div class="form-group ts-h-full">
                <form class="ts-h-full">
                  <fieldset class="ts-h-full">
                    <legend>{{ $t('invoice.createFrom') }}</legend>
                    <a-tabs default-active-key="1">
                      <a-tab-pane key="1" :tab="$t('invoice.studentInClass')">
                        <student-list @seleted="onPickStudent" />
                      </a-tab-pane>
                      <a-tab-pane
                        key="2"
                        :tab="$t('invoice.preInvoice')"
                        force-render
                      >
                        <pre-invoice-list @selected="onPickPreInvoice" />
                      </a-tab-pane>
                    </a-tabs>
                  </fieldset>
                </form>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group ts-h-full">
                <form class="ts-h-full">
                  <fieldset class="ts-h-full">
                    <legend>{{ $t('invoice.infoRelateStudent') }}</legend>
                    <a-tabs
                      v-model="key_tab_relate_info_active"
                      :default-active-key="1"
                      @change="relateStudentInfoTablChange"
                    >
                      <a-tab-pane :key="1" :tab="$t('invoice.academicInfo')">
                        <academic-info
                          :academic="academic"
                          :vehicle-register="vehicle_register"
                          v-model="model"
                          :validate="errors"
                        />
                      </a-tab-pane>
                      <a-tab-pane
                        :key="3"
                        :tab="$t('invoice.latestInvoice')"
                        force-render
                        :disabled="!allow_view_latest_invoice"
                      >
                        <latest-invoice
                          :is-active="key_tab_relate_info_active"
                          :student-id="bind_student_id"
                          :acp-id="model.acp_id"
                        />
                      </a-tab-pane>
                      <a-tab-pane
                        :key="4"
                        force-render
                        v-if="showRegisterVehicleTab"
                      >
                        <span slot="tab">
                          {{ $t('invoice.registerVehicle') }}
                          <span class="text-red">*</span>
                        </span>
                        <vehicle-operation
                          :lists="vehicle_operation_lists"
                          :loading="loading_vehicle"
                          @reload="getVehicleOperationList"
                          @vehicle="id => (model.vehicle_id = id)"
                        />
                      </a-tab-pane>
                    </a-tabs>
                  </fieldset>
                </form>
              </div>
            </div>
          </div>
          <div class="row ts-mt-4">
            <div class="col-md-12">
              <div class="form-group">
                <panel :title="$t('invoice.itemList')">
                  <manual-detail
                    v-model="model"
                    :pre-details="preDetails"
                    :validate="errors"
                    :loading-pre-inv="loading_pre_inv"
                    :bank="bankProfiles"
                    ref="manualDetail"
                  />
                  <div v-if="errors.has('inv_detail_list')" class="validate">
                    {{ errors.first('inv_detail_list') }}
                  </div>
                  <template slot="footer">
                    <div class="row">
                      <div class="col-md-12 text-right">
                        <ts-button
                          @click.prevent="$router.push({ name: 'invoice' })"
                          >{{ $t('cancel') }}</ts-button
                        >
                        <ts-button
                          :waiting="save_print"
                          color="primary"
                          outline
                          class="ml-2"
                          @click.prevent="savePrint"
                          >{{ $t('savePrint') }}</ts-button
                        >
                        <ts-button
                          :waiting="waiting"
                          @click.prevent="save"
                          color="primary"
                          class="ml-2"
                          >{{ $t('save') }}</ts-button
                        >
                      </div>
                    </div>
                  </template>
                </panel>
              </div>
            </div>
          </div>
        </ts-loading-banner>
        <pdf-preview
          v-model="pdf_view"
          :invoice-id="invoiceId"
          @cancel="value => (pdf_view = value)"
        />
      </ts-card-wrapper>
    </ts-card>
  </div>
</template>
<script>
import moment from 'moment'
import { mapActions, mapState } from 'vuex'
import { Errors } from 'form-backend-validation'
import StudentList from './component/student_list'
import PreInvoiceList from './component/pre_invoice_list'
import AcademicInfo from './component/academic'
import LatestInvoice from './component/latest_invoice'
import ManualDetail from './component/manual_create_details'
import VehicleOperation from './component/vehicle_operation_list'
import PdfPreview from './component/pdf_preview'
import { sumBy } from 'lodash'

export default {
  name: 'invoiceCreateForm',
  components: {
    StudentList,
    PreInvoiceList,
    AcademicInfo,
    LatestInvoice,
    ManualDetail,
    VehicleOperation,
    PdfPreview
  },
  data() {
    return {
      model: {
        pre_inv_id: 0,
        inv_date: moment().format('DD-MM-YYYY'),
        student_id: null,
        ac_year_id: null,
        acp_id: null,
        acps_id: null,
        ac_term_id: null,
        class_id: null,
        grade_id: null,
        total_amount: 0,
        amount_paid: 0,
        amount_due: 0,
        next_payment_date: null,
        remark: null,
        inv_detail_list: [],
        fee_group_id: null,
        vehicle_id: null,
        promtion_expired_date: null, // just variable show a promotion date not use to store in DB
        ac_term_stop_date: null, // just make validate not allow over stop date
        ac_term_start_date: null, // for validate less than start date,
        payment_method_id: '',
        bank_id: null,
        pro_type_id: null,
        amount_paid_khr: 0,
        amount_paid_usd: 0,
        fx_rate: 0,
        study_time: '',
        discount_type: '%',
        discount_value: 0,
        discounted_amount: 0
      },
      key_tab_relate_info_active: 1,
      bind_grade_id: null,
      bind_student_id: null,
      academic: {
        student_name: null,
        ac_year: null,
        main_program: null,
        grade: null,
        study_time: null,
        ac_term: null
      },
      exchanges: [],
      exchange_rate: 0,
      loading_eligable: false,
      waiting: false,
      loading_vehicle: false,
      loading_pre_inv: false,
      pdf_view: false,
      save_print: false,
      errors: new Errors(),
      vehicle_register: false,
      vehicle_operation_lists: [],
      preDetails: {},
      invoiceId: 0,
      bankProfiles: []
    }
  },
  computed: {
    ...mapState('invoice', ['promotionRate']),
    allow_view_fee_group_list() {
      return this.model.grade_id != null
    },
    allow_view_latest_invoice() {
      return this.model.student_id != null
    },
    mustBeRegisterVehicle() {
      // 3 for bus fee setup
      var findBusFee = this.model.inv_detail_list.filter(
        d => d.fee_type_id == 3
      )
      if (
        findBusFee.length > 0 &&
        this.vehicle_register == false &&
        this.model.vehicle_id == null
      ) {
        return true
      }
      return false
    },
    showRegisterVehicleTab() {
      var findBusFee = this.model.inv_detail_list.filter(
        d => d.fee_type_id == 3
      )
      if (findBusFee.length > 0 && this.vehicle_register == false) {
        return true
      }
      return false
    },
    allow_duplicate_fee_type() {
      return this.$store.state.authUser.allow_duplicate_fee_type
    }
  },
  created() {
    this.getDefaultCreditDay({
      fields: {
        setup_default_credit_days: 'credit_day'
      }
    })
  },
  methods: {
    ...mapActions('invoice', [
      'getDefaultCreditDay',
      'store',
      'registerVehicel',
      'getVehicleOperation',
      'getPromotion',
      'eligable',
      'bankStudent',
      'getClassId'
    ]),
    async onPickStudent(student) {
      this.loading_eligable = true

      let eligable_pay = await this.eligable({
        student_id: student.student_id,
        term_id: student.academic_class.ac_term_id
      }).finally(() => {
        this.loading_eligable = false
      })

      if (eligable_pay.data.length > 0) {
        let response = eligable_pay.data[0]

        const h = this.$createElement
        this.$info({
          title: 'Unpaid Payment',
          zIndex: 1020,
          centered: true,
          width: '600px',
          content: h('div', {}, [
            h('p', {}, [
              h('span', 'The student name: '),
              h(
                'b',
                { class: 'ts-text-red-700' },
                student.student_profile.full_name_en
              ),
              h('span', ' is not fully paid.')
            ]),
            h('p', {}, [
              h('span', 'Term name: '),
              h('b', { class: 'ts-text-red-700' }, response.term_name),
              h('span', ' Start Date: '),
              h(
                'span',
                { class: 'ts-text-red-700' },
                response.term_start
                  ? moment(response.term_start, 'YYYY-MM-DD').format(
                      'DD-MM-YYYY'
                    )
                  : ''
              ),
              h('span', ' End Date: '),
              h(
                'span',
                { class: 'ts-text-red-700' },
                response.term_stop
                  ? moment(response.term_stop, 'YYYY-MM-DD').format(
                      'DD-MM-YYYY'
                    )
                  : ''
              )
            ]),
            h('p', 'Term Order: ' + response.term_order),
            h('p', 'Class name: ' + response.class_name)
          ]),
          onOk() {}
        })
        return
      }
      // set value to display at academic tab
      this.academic = {
        student_name: student.student_profile.full_name_en,
        ac_year: student.academic_class.academic_year.ac_year,
        main_program: student.academic_class.main_program.acp_name_foreign,
        grade: student.academic_class.grade.grade_name_foreign,
        study_time: student.academic_class.academic_study_time.study_time,
        ac_term: student.academic_class.academic_term.term_name
      }

      // set value to model before submit to server
      this.model.pre_inv_id = 0
      this.model.student_id = student.student_id
      this.model.ac_year_id = student.academic_class.ac_year_id
      this.model.acp_id = student.academic_class.acp_id
      this.model.acps_id = student.academic_class.acps_id
      this.model.ac_term_id = student.academic_class.ac_term_id
      this.model.class_id = student.academic_class.class_id
      this.model.grade_id = student.academic_class.grade_id
      this.model.ac_term_stop_date =
        student.academic_class.academic_term.term_stop
      this.model.ac_term_start_date =
        student.academic_class.academic_term.term_start
      this.model.promtion_expired_date = null

      this.model.study_time =
        student.academic_class.academic_study_time.study_time

      // set tab to default tab
      this.key_tab_relate_info_active = 1

      // set room type _id
      this.$store.commit(
        'invoice/SET_ROOM_TYPE_ID',
        student.academic_class.room.room_type_id
      )

      // set error validate to default
      this.errors = new Errors()

      // check student register
      let response = await this.registerVehicel(student.student_id)
      this.vehicle_register = response.register

      // vehicle operation list
      this.getVehicleOperationList()

      // Get bank student profile
      let bankStudent = await this.bankStudent(student.student_id)
      this.bankProfiles = bankStudent.data
    },
    async onPickPreInvoice(preInvoice) {
      this.loading_pre_inv = true
      // get promotion rate
      await this.getPromotion({
        condition: {
          acps_id: preInvoice.acps_id,
          ac_term_id: preInvoice.ac_term_id
        }
      })
      // Get bank student profile
      let bankStudent = await this.bankStudent(preInvoice.student_id)
      this.bankProfiles = bankStudent.data

      // get class id if student has been enroll
      let classOpt = await this.getClassId({
        grade_id: preInvoice.grade.grade_id,
        ac_term_id: preInvoice.academic_term.ac_term_id,
        student_id: preInvoice.student.student_id
      })

      if (classOpt.data.length > 0) {
        this.model.class_id = classOpt.data[0].class_id
      }

      this.loading_pre_inv = false
      // set room type _id
      this.$store.commit('invoice/SET_ROOM_TYPE_ID', 0)
      // set error validate to default
      this.errors = new Errors()
      //set value to display at academic tab
      this.academic = {
        student_name: preInvoice.student.full_name_en,
        ac_year: preInvoice.academic_year.ac_year,
        main_program: preInvoice.main_program.acp_name_foreign,
        grade: preInvoice.grade.grade_name_foreign,
        study_time: preInvoice.study_time,
        ac_term: preInvoice.academic_term.term_name
      }

      // set value to model before submit to server
      this.model.pre_inv_id = preInvoice.inv_id
      this.model.student_id = preInvoice.student_id
      this.model.ac_year_id = preInvoice.ac_year_id
      this.model.acp_id = preInvoice.acp_id
      this.model.acps_id = preInvoice.acps_id
      this.model.ac_term_id = preInvoice.ac_term_id
      // this.model.class_id = preInvoice.class_id
      this.model.grade_id = preInvoice.grade_id
      this.model.ac_term_stop_date = preInvoice.academic_term.term_stop
      this.model.ac_term_start_date = preInvoice.academic_term.term_start
      this.model.promtion_expired_date = null

      this.model.remark = preInvoice.remark

      this.model.study_time = preInvoice.study_time

      this.preDetails = preInvoice.pre_invoice_detail.reduce((obj, el) => {
        // Destructure with default value for discount_type
        const { fee_type, fee_setup, discount_type = '%', ...data } = el
        const feeTypeId = fee_type.fee_type_id

        // Calculate promotion-related values once
        const isRegularFee = feeTypeId === 1
        const promotionExpiryDate = isRegularFee
          ? this.promotionRate.promotion_expiry_date
          : null

        // Determine discount rate based on fee type and promotion rate
        let discountRate = data.discount_rate
        if (isRegularFee) {
          const promotionRate = parseFloat(this.promotionRate.promotion_rate)
          const currentRate = parseFloat(data.discount_rate)
          discountRate =
            promotionRate > currentRate
              ? this.promotionRate.promotion_rate
              : data.discount_rate
        }

        // Create the new item object
        const newItem = {
          ...data,
          discount_type,
          fee_name: fee_setup.fee_name_en,
          promotion_expiry_date: promotionExpiryDate,
          discount_rate: discountRate
        }

        // Initialize the array if it doesn't exist, then push the new item
        if (!obj[feeTypeId]) {
          obj[feeTypeId] = []
        }
        obj[feeTypeId].push(newItem)

        return obj
      }, {})
    },
    relateStudentInfoTablChange(activeKey) {
      this.key_tab_relate_info_active = parseInt(activeKey)
      // tab index 2 for fee group
      if (activeKey == 2) {
        this.bind_grade_id = this.model.grade_id
      }
      // tab index 3 for latest invoice
      if (activeKey == 3) {
        this.bind_student_id = this.model.student_id
      }
    },
    getVehicleOperationList() {
      //get vehicle operation list
      if (!this.vehicle_register) {
        this.loading_vehicle = true
        this.getVehicleOperation({
          include:
            'operations,operations.vehicle_zone,operations.driver,employee',
          fields: {
            operations: 'vehicle_id,zone_id,driver_staff_id',
            'operations.vehicle_zone': 'zone_id,zone_name_en',
            setup_transportation_vehicle_info:
              'vehicle_id,plate_no,max_student,vehicle_assistant_staff_id',
            'operations.driver': 'staff_id,name_en',
            employee: 'staff_id,name_en'
          },
          page: -1
        })
          .then(response => {
            this.vehicle_operation_lists = response.data
          })
          .catch(error => {
            this.$toasted.error(error.message)
            this.errors = new Errors(error.errors)
          })
          .finally(() => {
            this.loading_vehicle = false
          })
      }
    },
    async save() {
      await this.checkAmountDetail()
        .then(async () => {
          this.errors = new Errors()
          if (this.mustBeRegisterVehicle) {
            this.key_tab_relate_info_active = 4
            this.$toasted.info(this.$t('invoice.plzregisterVehicle'))
            return
          }
          this.waiting = true
          if (
            await this.checkIsDuplicateFeeType({
              student_id: this.model.student_id,
              fee_type_list: this.model.inv_detail_list,
              ac_term_id: this.model.ac_term_id
            })
          ) {
            this.waiting = true
            this.store(this.model)
              .then(response => {
                this.$toasted.success(response.message)
                this.clearInput()
                this.key_tab_relate_info_active = 1
                this.$router.push({ name: 'invoice' })
              })
              .catch(error => {
                this.$toasted.error(error.message)
                this.errors = new Errors(error.errors)
              })
              .finally(() => {
                this.waiting = false
              })
          }
        })
        .catch(error => {
          this.refreshCalculate()
        })
    },
    async savePrint() {
      await this.checkAmountDetail()
        .then(async () => {
          this.errors = new Errors()
          // student must register to vehicle if buy bus fee and student not yet register to which vehicle
          if (this.mustBeRegisterVehicle) {
            this.key_tab_relate_info_active = 4
            this.$toasted.info(this.$t('invoice.plzregisterVehicle'))
            return
          }
          this.save_print = true
          if (
            await this.checkIsDuplicateFeeType({
              student_id: this.model.student_id,
              fee_type_list: this.model.inv_detail_list,
              ac_term_id: this.model.ac_term_id
            })
          ) {
            this.save_print = true
            this.store(this.model)
              .then(response => {
                this.$toasted.success(response.message)
                this.clearInput()
                this.invoiceId = response.id
                this.pdf_view = true
                this.key_tab_relate_info_active = 1
              })
              .catch(error => {
                this.$toasted.error(error.message)
                this.errors = new Errors(error.errors)
              })
              .finally(() => {
                this.save_print = false
              })
          }
        })
        .catch(error => {
          this.refreshCalculate()
        })
    },
    clearInput() {
      this.model.pre_inv_id = 0
      this.model.inv_date = moment().format('DD-MM-YYYY')
      this.model.student_id = null
      this.model.ac_year_id = null
      this.model.acp_id = null
      this.model.acps_id = null
      this.model.ac_term_id = null
      this.model.class_id = null
      this.model.grade_id = null
      this.model.total_amount = 0
      this.model.amount_paid = 0
      this.model.amount_due = 0
      this.model.next_payment_date = null
      this.model.remark = null
      this.model.inv_detail_list = []
      this.model.fee_group_id = null
      this.model.vehicle_id = null
      this.model.promtion_expired_date = null
      this.preDetails = {}
      this.model.payment_method_id = null
      this.model.bank_id = null
      this.model.pro_type_id = null
      this.model.amount_paid_usd = 0
      this.model.amount_paid_khr = 0
      this.model.discount_type = '%'
      this.model.discount_value = 0
      this.model.discounted_amount = 0
    },
    async checkIsDuplicateFeeType(data) {
      try {
        if (this.allow_duplicate_fee_type) {
          // ask for confirm when duplicate fee type setting on company profile
          let response = await this.$store.dispatch(
            'invoice/checkIsDuplicateFeeType',
            data
          )
          if (response) {
            this.waiting = false
            if (
              await this.$confirmModal.danger(
                '<span class="text-warning">Duplicate fee type! Do you want to continue?</span>'
              )
            ) {
              return true
            } else {
              return false
            }
          }
          return true
        }
        return true
      } catch (error) {
        this.errors = new Errors(error.errors)
        this.$toasted.error(error.message)
        this.waiting = false
      }
    },
    checkAmountDetail() {
      const sumDetail = sumBy(this.model.inv_detail_list, 'amount_include_vat')
      if (this.model.total_amount !== sumDetail) {
        return new Promise((resolve, reject) =>
          reject('The value total amount not equal to detail.')
        )
      }
      return new Promise((resolve, reject) => resolve('Correct'))
    },
    refreshCalculate() {
      const h = this.$createElement
      this.$warning({
        title: 'Warning',
        zIndex: 1020,
        centered: true,
        width: '400px',
        content: h('div', {}, [
          h('p', {}, [
            h('span', 'The value total amount not equal to detail.'),
            h('br'),
            h('span', ' Click on OK button to recalculate')
          ])
        ]),
        onOk: () => {
          this.$refs.manualDetail.calculate()
        }
      })
    }
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('invoice/RESET_STATE')
    this.clearInput()
    next()
  }
}
</script>

<style lang="css" scoped>
* {
  font-size: 12px !important;
}

.page-header {
  font-size: 24px !important;
}

.panel {
  margin-bottom: -24px !important;
}
</style>
